import { ProductModel } from './ProductModel';

export class ProductReferenceModel {
    public quantity: number;

    public target: ProductModel;
}